import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    background-color: ${colors.brandDark};
    margin-top: auto;
`;

export const Inner = styled.div`
    position: relative;
    padding: 1px 0;
    .regionnotselected { align-items: flex-start;  }
    .mobilefooterlink { margin: 30px 0; }
    .mobileregioninfo { margin: 70px 0 40px; }
`;

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${colors.white};
    margin: 30px 0;
    opacity: 0.25;
`;

export const AckRegionWrapper = styled.div`
    ${breakpoints.large} {
        margin: 40px 0;
        display: flex;
        align-items: center;
        > * {
            width: 50%;
        }
        .acknowledge-desktop p:nth-child(2) {
            margin-bottom: 0px;
        }
        .acknowledge-left {
            margin-right: 2%;
        }
        .acknowledge-left p {
            margin-bottom: 0px;
        }
        .acknowledge-right {
            margin-left: 2%;
        }
        .acknowledge-right p{
            margin-bottom: 0px;
        }
    }
`;

export const Copyright = styled.div`
    color: white;
    margin: 30px 0;
    font-size: 15px;
    font-weight: 400;

    ${breakpoints.large} {
        text-align: center;
        margin: 30px 0;
    }
`;
